/**
 * Данный файл предназначен для отслеживания переходов на всех страницах сайта
 */
//Параметры по умолчанию (настройки)
App.newpartners = {
    constants: {
        tl: {
            //с каких страниц считать переходы и сохранять ext params для пробного урока
        },
        order: {
            //с каких страниц считать переходы и сохранять ext params для заказа
        }
    }
};

/**
 * Параметры всех партнерский сетей для отслеживания пробных уроков
 *
 * recl - массив с кодами рекламы
 * params: {uniq: 'track_id', chan: 'refid'} - ext params для записи с заказом в связанную таблицу
 *                                           - по этим параметрам будут уходить постбек
 * orderConfirm - колбек для отправки данных партнеру. Возвращает промис JQuery
 */
App.newpartners.constants.tl.identifies = {
    admitad: {
        recl: [84465],
        params: {
            uniq: 'click_hash',
            chan: 'refid'
        },
        orderConfirm: function (data) {
            console.log('admitad tl confirmed!!!');
            var defer = $.Deferred();
            var actionCode = 4;


            // ADMITAD pixel begin
            ADMITAD = window.ADMITAD || {};
            ADMITAD.Invoice = ADMITAD.Invoice || {};
            ADMITAD.Invoice.broker = "adm";     // параметр дедупликации (по умолчанию для admitad)
            ADMITAD.Invoice.category = actionCode;     // код целевого действия (определяется при интеграции)

            var orderedItem = [];               // временный массив для товарных позиций
            orderedItem.push({
                Product: {
                    productID: encodeURIComponent(data.test_lesson.courses_id), // id курса
                    category: 1,               // код тарифа (определяется при интеграции)
                    price: 0,          // цена товара
                    priceCurrency: "RUB",        // код валюты ISO-4217 alfa-3
                },
                orderQuantity: 1,   // количество товара
                additionalType: "sale"           // всегда sale
            });

            ADMITAD.Invoice.referencesOrder = ADMITAD.Invoice.referencesOrder || [];
            // добавление товарных позиций к заказу
            ADMITAD.Invoice.referencesOrder.push({
                orderNumber: encodeURIComponent(data.test_lesson.id), // внутренний номер заказа (не более 100 символов)
                orderedItem: orderedItem
            });
            ADMITAD.Tracking.processPositions();
            // ADMITAD pixel end
            defer.resolve();
            return defer;
        }
    },
    mnogoru: {
        recl: [86059],
        params: {
            uniq: 'cardnum', // номер карты
            chan: 'srcid' // откуда пришли - mnogoru
        },
        orderConfirm: function (data) {
            console.log('mnogoru tl confirmed!!!');
            var defer = $.Deferred();
            // MNOGORU PIXEL CODE
            // Его нет :-(
            // MNOGORU PIXEL CODE
            defer.resolve();
            return defer;
        }
    },
    advertise: {
        recl: [84399],
        params: {uniq: 'click_hash', chan: 'refid'},
        orderConfirm: function (data) {
            console.log('advertise tl confirmed!!!');
            var img = new Image();
            var defer = $.Deferred();

            img.setAttribute('height', '1');
            img.setAttribute('width', '1');

            img.src = "//advertiseru.net/tracking/c12113f75203426b/img/?uid="
                + encodeURIComponent(data.uniq) + '&order_id='
                + encodeURIComponent(data.test_lesson.id);

            img.onload = function () {
                defer.resolve();
            };

            return defer;
        }
    },
    /*
    leadMagnet: {
        recl: [86200],
        params: {
            uniq: 'utm_content', // узнать какой параметр меняется
            chan: 'utm_campaign'
        },
        orderConfirm: function (data) {
            console.log('leadMagnet tl confirmed!!!');
            var defer = $.Deferred();
            defer.resolve();
            return defer;
        }
    },
    */
    Adsalsa: {
        recl: [86508],
        params: {
            uniq: 'utm_content', // узнать какой параметр меняется
            chan: 'utm_campaign'
        },
        orderConfirm: function (data) {
            console.log('Adsalsa tl confirmed!!!');
            var defer = $.Deferred();
            defer.resolve();
            return defer;
        }
    },
    /*
    Salid: {
        recl: [87209],
        params: {
            uniq: 'utm_term', // узнать какой параметр меняется
            chan: 'utm_campaign'
        },
        orderConfirm: function (data) {
            console.log('Salid tl confirmed!!!');
            var defer = $.Deferred();
            defer.resolve();
            return defer;
        }
    },
    Saleads: {
        recl: [87470],
        params: {
            uniq: 'click',
            chan: 'srcid'
        },
        orderConfirm: function (data) {
            console.log('Saleads tl confirmed!');
            var defer = $.Deferred();
            defer.resolve();
            return defer;
        }
    },
    */
    gdeslon: {
        recl: [87865],
        params: {
            uniq: '_gs_ref',
            chan: 'gsaid'
        },
        orderConfirm: function (data) {
            console.log('gdeslon tl confirmed!');
            var defer = $.Deferred();
            var orderId = encodeURIComponent(data.test_lesson.id);
            var userId = encodeURIComponent(data.Profiles.email);

            window.gdeslon_q = window.gdeslon_q || [];
            window.gdeslon_q.push({
                page_type:  "thanks",
                merchant_id: "98970",
                order_id: orderId,
                products: [ // 002 - псевдотовар для пробного урока
                    { id: "002", price: 1, quantity: 1 }
                ],
                deduplication: "gdeslon",
                user_id: userId
            });

            defer.resolve();
            return defer;
        }
    },
    cityads: {
        recl: [88640],
        params: {
            uniq: 'click_id',
            chan: 'utm_campaign' // метка веб-мастера
        },
        orderConfirm: function (data) {
            console.log('CityAds tl confirmed!');
            var defer = $.Deferred();
            // PIXEL CODE
            // ...
            // PIXEL CODE
            defer.resolve();
            return defer;
        }
    }
};

/**
 * Параметры всех партнерский сетей для отслеживания заказов
 *
 * recl - массив с кодами рекламы
 * params: {uniq: 'track_id', chan: 'refid'} - ext params для записи с заказом в связанную таблицу
 *                                           - по этим параметрам будут уходить постбек
 * orderConfirm - колбек для отправки данных партнеру. Возвращает промис JQuery
 */
App.newpartners.constants.order.identifies = {
    admitad: {
        recl: [84465],
        params: {
            uniq: 'click_hash',
            chan: 'refid'
        },
        orderConfirm: function (data) {
            console.log('admitad order confirmed!!!');
            var defer = $.Deferred();

            var actionCode = 5;
            var price = parseInt(data.courseInfo.modPrice);
            if (data.pk) {
                price = parseInt(data.courseInfo.modTotal);
            }

            // ADMITAD pixel begin
            ADMITAD = window.ADMITAD || {};
            ADMITAD.Invoice = ADMITAD.Invoice || {};
            ADMITAD.Invoice.broker = "adm";     // параметр дедупликации (по умолчанию для admitad)
            ADMITAD.Invoice.category = actionCode;     // код целевого действия (определяется при интеграции)

            var orderedItem = [];               // временный массив для товарных позиций
            orderedItem.push({
                Product: {
                    productID: encodeURIComponent(data.courses_id), // id курса
                    category: 1,               // код тарифа (определяется при интеграции)
                    price: price,          // цена товара
                    priceCurrency: "RUB",        // код валюты ISO-4217 alfa-3
                },
                orderQuantity: 1,   // количество товара
                additionalType: "sale"           // всегда sale
            });

            ADMITAD.Invoice.referencesOrder = ADMITAD.Invoice.referencesOrder || [];
            // добавление товарных позиций к заказу
            ADMITAD.Invoice.referencesOrder.push({
                orderNumber: encodeURIComponent(data.order_id), // внутренний номер заказа (не более 100 символов)
                orderedItem: orderedItem
            });
            ADMITAD.Tracking.processPositions();
            // ADMITAD pixel end
            defer.resolve();
            return defer;
        }
    },
    mnogoru: {
        recl: [86059],
        params: {
            uniq: 'cardnum', // номер карты
            chan: 'srcid' // откуда пришли - mnogoru
        },
        orderConfirm: function (data) {
            console.log('mnogoru order confirmed!!!');
            var defer = $.Deferred();
            // MNOGORU PIXEL CODE
            // Его нет :-(
            // MNOGORU PIXEL CODE
            defer.resolve();
            return defer;
        }
    },
    advertise: {
        recl: [84399],
        params: {uniq: 'click_hash', chan: 'refid'},
        pathname: ['/order-form-partners'],
        orderConfirm: function (data) {
            console.log('advertise order confirmed!!!');
            var img = new Image();
            var defer = $.Deferred();

            img.setAttribute('height', '1');
            img.setAttribute('width', '1');

            img.onload = function () {
                defer.resolve();
            };

            ///c12113f75d03426b - Заявка на оплату курса помесячно
            var trackingCode = 'c12113f75d03426b';
            if (data.pk) {
                trackingCode = 'c12113f75c03426b'
                ///c12113f75c03426b - Заявка на оплату полного курса обучения
            }

            img.src = "//advertiseru.net/tracking/" + trackingCode + "/img/?uid="
                + encodeURIComponent(data.uniq)
                + '&order_id=' + encodeURIComponent(data.order_id);

            return defer;
        }
    },
    // бывший tradeLeads теперь leadsSu, используем псевдо-пиксел
    leadsSu: {
        recl: [87867, 87868, 87869],
        params: {uniq: 'transaction_id', chan: 'cpa_webmaster_id'},
        orderConfirm: function (data) {
            console.log('leadsSu order confirmed!!!');
            var img = new Image();
            var defer = $.Deferred();

            img.setAttribute('height', '1');
            img.setAttribute('width', '1');

            img.onload = img.onerror = function () {
                defer.resolve();
            };

            var goal_id = '0';
            var adv_sub = encodeURIComponent(data.order_id);
            // Помесячная оплата курса
            var comment = 'Monthly_payment';
            var amount = Number(data.courseInfo.modPrice);
            // Оплата полного курса сразу
            if (data.pk) {
                var comment = 'Full_payment';
                amount = Number(data.courseInfo.modTotal);
            }

            amount = amount.toFixed(2);

            img.src = "http://api.leads.su/advertiser/conversion/createUpdate?token=7eaf6b012d32a759835fcc2430811640&goal_id="
                + goal_id + "&transaction_id=" + encodeURIComponent(data.uniq) + "&adv_sub="
                + adv_sub + "&status=pending&amount=" + amount + "&comment=" + comment;

            return defer;
        }
    },
    gdeslon: {
        recl: [87865],
        params: {
            uniq: '_gs_ref',
            chan: 'gsaid'
        },
        orderConfirm: function (data) {
            console.log('gdeslon order confirmed!');
            var defer = $.Deferred();
            var orderId = encodeURIComponent(data.order_id); // внутренний номер заказа
            var courseId = encodeURIComponent(data.courses_id); // id курса
            var userId = encodeURIComponent(data.email); // идентификатор пользователя (email)
            var price = encodeURIComponent(data.selectedPrice); // цена курса со всеми скидками и без доставки (ее видит пользователь)

            window.gdeslon_q = window.gdeslon_q || [];
            window.gdeslon_q.push({
                page_type:  "thanks",
                merchant_id: "98970",
                order_id: orderId,
                products: [ // 001 - псевдотовар для заказа курса
                    { id: courseId, price: price, quantity: 1 },
                    { id: "001", price: price, quantity: 1 }
                ],
                deduplication: "gdeslon",
                user_id: userId
            });

            defer.resolve();
            return defer;
        }
    },
    cityads: {
        recl: [88640],
        params: {
            uniq: 'click_id',
            chan: 'utm_campaign' // метка веб-мастера
        },
        orderConfirm: function (data) {
            console.log('CityAds order confirmed!');
            var defer = $.Deferred();
            // PIXEL CODE
            // ...
            // PIXEL CODE
            defer.resolve();
            return defer;
        }
    }
};

/**
 * Всегда проверяем наличие нужных нам get параметров в строке, для идентификации партнерского перехода
 * {"slug":"order-form-partners","recl":"84465","srcid":"admitad","click_hash":"test","refid":"13130","subid":"{$subid}","utm_source":"admitad","utm_medium":"cpa","utm_campaign":"order_partners"}
 */
App.newpartners.saveFirstVisit = function () {
    var queryParams = App.queryString;

    if (queryParams.hasOwnProperty('recl') && queryParams.hasOwnProperty('srcid') && queryParams.hasOwnProperty('utm_source')) {
        queryParams.recl = parseInt(queryParams.recl);
        //проверяем что код рекламы 5 знаков
        if (queryParams.recl >= 9999) {
            // тут наоборот, если есть кука эдуграма, удаляем ее
            if (App.cookie.get('edugram_visit')) {
                App.cookie.set('edugram_visit', '', {expires: -1});
            }

            // сохраняем все в куки
            const PARTNERS_COOKIE_NAME = 'partners_lead_visit';
            const PARTNERS_COOKIE_STORE_DAYS = 90;

            App.cookie.set(
                PARTNERS_COOKIE_NAME,
                JSON.stringify(queryParams),
                {expires: PARTNERS_COOKIE_STORE_DAYS * 60 * 60 * 24, path:'/'}
            );
            console.log('PARTNERS: First visit params saved for - ' + queryParams.srcid);
            return true;
        }
    }
    return false;
};

// exec
App.newpartners.saveFirstVisit();

/**
 * Получаем параметры партнерской сети для отчета
 * Все что ниже, происходит непосредственно при заказе
 *
 * @param type
 * @returns {*}
 */
App.newpartners.getIdentifyPostBack = function (type) {
    var cookieParams = JSON.parse(App.cookie.get('partners_lead_visit'));

    if  (typeof App.cookie.get('partners_lead_visit') === 'undefined') {
        return false;
    }

    if (typeof type === 'undefined') {
        return false;
    }

    if (!App.newpartners.constants.hasOwnProperty(type)) {
        return false;
    }

    var identifies = App.newpartners.constants[type].identifies;

    if (App.cookie.get('channel_code') != JSON.parse(App.cookie.get('partners_lead_visit')).recl) {
        return false;
    }

    /**
     * Пробуем получить параметры GET параметры в cookie по партнеру
     * @param params
     * @returns {*}
     */
    function tryToGetPartnerParamsFromCookie(params) {
        var extParams = {};

        for (var paramName in params) {
            //не верные настройки партнера
            if (!params.hasOwnProperty(paramName)) {
                return false;
            }

            var nameInUrl = params[paramName];

            if (!cookieParams.hasOwnProperty(nameInUrl)) {
                return false;
            }

            extParams[paramName] = cookieParams[nameInUrl];
        }

        return extParams;
    }

    /**
     * Получаем текущего партнера
     * @returns {*}
     */
    function getPartnerParams() {

        for (var partner in identifies) {
            //не верные настройки партнера или не найден код рекламы партнера или параметры партнера
            if (!identifies.hasOwnProperty(partner) || (identifies[partner].recl.indexOf(cookieParams.recl) === -1)) {
                continue;
            }
            var extParams = tryToGetPartnerParamsFromCookie(identifies[partner].params);
            if (!extParams) {
                continue;
            }
            return {extParams: extParams, orderConfirm: identifies[partner].orderConfirm};
        }

        return false;
    }

    return getPartnerParams();
};

App.newpartners.processGdeSlon = function (data) {
    var defer = $.Deferred();
    var slonRecl = '87865';
    var deduplication = App.cookie.get('channel_code') ? App.cookie.get('channel_code') : '';
    var userId = data ? encodeURIComponent(data) : '';

    if (deduplication != slonRecl ||
        (typeof App.cookie.get('partners_lead_visit') !== 'undefined'
        && (JSON.parse(App.cookie.get('partners_lead_visit')).recl != slonRecl))) {

        // удаляем куку слона, ибо он не последний источник (также удаляется в php при изменении channel_code)
        if (App.cookie.get('gdeslon.ru.__arc_token')) {
            var domain = location.hostname || location.host.split(":")[0];
            var domainParts = domain.split(".");
            var l = domainParts.length;
            if (l > 1) {
                domain = domainParts[l - 2] + "." + domainParts[l - 1];
            }
            document.cookie = 'gdeslon.ru.__arc_token=;path=/;Max-Age=0;domain=.' + domain;
        }

        window.gdeslon_q = window.gdeslon_q || [];
        window.gdeslon_q.push({
            page_type:  "thanks",
            merchant_id: "98970",
            deduplication: deduplication,
            user_id: userId
        });
    }

    defer.resolve();
    return defer;
};
